// ═══════════════════════════════════════════════════════════════════════════
// VERIFICA DELL'EMAIL — aziende registrate dal W446 (campo verificaEmailRichiesta)
// ═══════════════════════════════════════════════════════════════════════════
// Si entra subito; l'email va confermata per invitare i colleghi e, entro GIORNI_VERIFICA_EMAIL
// giorni dalla registrazione, per continuare a inserire dati (dopo si può solo consultare).
// Chi entra con un invito ha l'email già confermata (il link è arrivato lì).
// Stessa regola nelle Regole Firestore 73 (emailInRegola) e in functions/registrazione.js.
// ═══════════════════════════════════════════════════════════════════════════
export const GIORNI_VERIFICA_EMAIL = 7;
const GIORNO = 86400000;
const comeData = (v) => v?.toDate ? v.toDate() : (v instanceof Date ? v : (v?.seconds ? new Date(v.seconds * 1000) : (v ? new Date(v) : null)));

export function statoVerificaEmail({ org, emailVerificata, adesso = new Date() }) {
  if (!org || org.verificaEmailRichiesta !== true || emailVerificata) return { richiesta: false, giorniRimasti: null, bloccata: false, scadenza: null };
  const creata = comeData(org.createdAt) || adesso;
  const scadenza = new Date(creata.getTime() + GIORNI_VERIFICA_EMAIL * GIORNO);
  return { richiesta: true, scadenza, giorniRimasti: Math.max(0, Math.ceil((scadenza - adesso) / GIORNO)), bloccata: adesso >= scadenza };
}
